import css from "../../css/listing/slider-thumbs.module.css";
import cssSlider from "../../css/listing/slider.module.css";

import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { useAuth } from "../common/Auth";
import { getListingPhotoUrl, LISTING_THUMB_340_200 } from "../../service/photo";

import doorIcon from "../../static/icons/door.png";
import { LISTING_ACTIVE_STATUS } from "../../service/listing";

const AuthModal = dynamic(() => import("../auth/AuthModal"), { ssr: false });

const SliderThumbs = (props) => {
    const { isAuthenticated } = useAuth();
    const thumbRef = useRef();

    const [scrollOffset, setScrollOffset] = useState(0);

    const { listing, onChange, activeIndex, onArchiveClick, forceActive } =
        props;

    let { primary_photo, photos, status } = listing;

    const isActive = status === LISTING_ACTIVE_STATUS;

    if (!photos || photos.length === 0) {
        photos = [primary_photo];
    }

    const scrollLeft = () => {
        thumbRef.current.scrollLeft -= 350;
        setScrollOffset(thumbRef.current.scrollLeft);
    };

    const scrollRight = () => {
        thumbRef.current.scrollLeft += 350;
        setScrollOffset(thumbRef.current.scrollLeft);
    };

    const handleLogin = () => {
        onArchiveClick();
    };

    if (!(isActive || forceActive) && photos && photos.length > 5) {
        photos = photos.slice(0, 5);
    }

    const thumbs = photos.map((photo, index) => {
        const photoUrl = getListingPhotoUrl(photo, LISTING_THUMB_340_200);

        if (isActive || forceActive) {
            // All ACTIVE LISTING
            // and
            // ARCHIVED USER LISTING - if the user who owns property or is Claimed property goes to it -> it will NOT show claim property stuff
            const activeClassName = activeIndex === index ? css.active : null;

            return (
                <div
                    onClick={() => onChange(index)}
                    key={index}
                    className={activeClassName}
                >
                    <img
                        src={photoUrl}
                        alt={listing.full_address}
                        onError={(event) =>
                            (event.target.style.display = "none")
                        }
                    />
                </div>
            );
        } else {
            // ARCHIVED LISTING
            if (isAuthenticated) {
                return (
                    <div
                        className={cssSlider.claimArchive}
                        title="Unlock Photos, Data & Manage this property"
                        onClick={onArchiveClick}
                        key={index}
                    >
                        <img
                            src={photoUrl}
                            alt={listing.full_address}
                            onError={(event) =>
                                (event.target.style.display = "none")
                            }
                        />
                        <div className={cssSlider.claim}>
                            <img
                                src={doorIcon.src}
                                alt={listing.full_address}
                            />{" "}
                            <span>Claim to Unlock</span>
                        </div>
                    </div>
                );
            } else {
                return (
                    <AuthModal
                        onSuccess={handleLogin}
                        useFullSignup={true}
                        key={index}
                    >
                        <div
                            className={cssSlider.claimArchive}
                            title="Unlock Photos, Data & Manage this property"
                        >
                            <img
                                src={photoUrl}
                                alt={listing.full_address}
                                onError={(event) =>
                                    (event.target.style.display = "none")
                                }
                            />
                            <div className={cssSlider.claim}>
                                <img
                                    src={doorIcon.src}
                                    alt={listing.full_address}
                                />{" "}
                                <span>Claim to Unlock</span>
                            </div>
                        </div>
                    </AuthModal>
                );
            }
        }
    });

    let offset = 0;
    let scrolledToEnd = false;

    if (thumbRef.current) {
        offset = thumbRef.current.scrollLeft;

        if (
            thumbRef.current.offsetWidth + offset ===
            thumbRef.current.scrollWidth
        ) {
            scrolledToEnd = true;
        }
    }

    return (
        <div className={css.container}>
            <div className={css.thumbnails} ref={thumbRef}>
                {thumbs}
            </div>

            {offset > 0 && (
                <button className={css.backBtn} onClick={scrollLeft} />
            )}
            {!scrolledToEnd && (
                <button className={css.forwardBtn} onClick={scrollRight} />
            )}
        </div>
    );
};

SliderThumbs.propTypes = {
    listing: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    activeIndex: PropTypes.number.isRequired,
    onArchiveClick: PropTypes.func.isRequired,
    forceActive: PropTypes.bool.isRequired,
};

export default SliderThumbs;
